<!-- TODO: CSS-1140 Add shimmer loading -->

<div class="card-container-title view-user-account-header-padding">
  <app-dark-back-button [paddingBottomRem]="0.5" (backClicked)="goBack()" />
  <span class="header">{{ user?.fullName }}</span>
</div>
<div class="card-container view-user-account-card-container-margin">
  <app-loading *ngIf="loadingOpts.isLoading" [options]="loadingOpts ?? undefined" />
  <div class="card-form-content-container">
    <div class="card-form-container">
      <!-- Information -->
      <app-base-card [height]="'100%'" class="info-card">
        <form [formGroup]="formGroup">
          <div class="grid-layout">
            <div class="d-flex flex-column gap-1">
              <label class="form-input-label" [for]="'firstName'" i18n>First Name</label>
              <app-text-input
                [error]="formSubmitAttempted && formGroup.controls.firstName.invalid"
                [formControlName]="'firstName'"
                [disabled]="!canEditUser"
                [controlId]="'firstName'" />
              <app-form-error
                *ngIf="formSubmitAttempted && formGroup.controls.firstName.invalid"
                [errors]="formGroup.controls.firstName.errors" />
            </div>
            <div class="d-flex flex-column gap-1">
              <label class="form-input-label" [for]="'lastName'" i18n>Last Name</label>
              <app-text-input
                [error]="formSubmitAttempted && formGroup.controls.lastName.invalid"
                [formControlName]="'lastName'"
                [disabled]="!canEditUser"
                [controlId]="'lastName'" />
              <app-form-error
                *ngIf="formSubmitAttempted && formGroup.controls.lastName.invalid"
                [errors]="formGroup.controls.lastName.errors" />
            </div>
            <div class="d-flex flex-column gap-1">
              <label class="form-input-label" [for]="'email'" i18n>Email</label>
              <app-text-input
                [error]="formSubmitAttempted && formGroup.controls.email.invalid"
                [formControlName]="'email'"
                [controlId]="'email'" />
            </div>
            <div class="d-flex flex-column gap-1">
              <label class="form-input-label" [for]="'status'" i18n>Status</label>
              <app-dropdown-input
                placeholder="Select"
                i18n-placeholder
                [dropdowns]="statusDropdowns"
                [error]="formSubmitAttempted && formGroup.controls.status.invalid"
                [formControlName]="'status'"
                [controlId]="'status'" />
            </div>
          </div>
          <hr class="role-divider" />
          <app-add-remove-role-form
            [gridLayout]="true"
            [submitAttempted]="formSubmitAttempted"
            [controlId]="'roles'"
            [formControlName]="'roles'"
            [user]="user ?? undefined"
            [addRoleMap]="userRoleMap ?? undefined" />
          <hr class="last-login-divider" />
        </form>

        <div *ngIf="userHasNotLoggedIn; else timestamp" class="flex-container flex-align-center">
          <div class="account-timestamp" i18n>User hasn't logged in yet.</div>
          <div class="primary-paddingless-text-button" (click)="resendInvite.emit(true)" i18n>Resend Invite?</div>
        </div>
        <ng-template #timestamp>
          <div class="d-flex flex-column gap-4" *ngIf="isEmployer$ | async">
            <div class="account-timestamp" *ngIf="!!user?.lastLoginDate">
              {{ lastLoginTime }}
            </div>
            <div class="account-timestamp" *ngIf="!user?.active && user?.setToInactiveString">
              {{ user?.setToInactiveString }}
            </div>
          </div>
          <div *ngIf="isInternal$ | async">
            <div class="account-timestamp" *ngIf="user?.active">{{ lastLoginTime }}</div>
            <div class="account-timestamp" *ngIf="!user?.active">
              {{ user?.setToInactiveString }}
            </div>
          </div>
        </ng-template>
      </app-base-card>
    </div>
    <div *ngIf="canEditUser" class="card-form-action-container">
      <app-base-card [height]="'100%'" [padding]="(isMobile$ | async) ? '2rem 1.5rem' : '2rem'">
        <div class="action-title" i18n>Actions</div>
        <div class="action-items-container">
          <div class="action-item">
            <img class="action-icon" [src]="'assets/icons/primary/Mail.svg'" alt="" />
            <span class="card-header" (click)="openChangeEmailModal.emit()" i18n>Change Email</span>
          </div>
          <div class="action-item">
            <img class="action-icon" [src]="'assets/icons/primary/Lock On.svg'" alt="" />
            <span class="card-header" (click)="resendInvite.emit(false)" i18n>Reset Password</span>
          </div>
          <div *ngIf="userHasNotLoggedIn" class="action-item">
            <img class="action-icon" [src]="'assets/icons/primary/RefreshLeft.svg'" alt="" />
            <span class="card-header" (click)="resendInvite.emit(true)" i18n>Resend Invite</span>
          </div>
        </div>
      </app-base-card>
    </div>
  </div>
  <ng-content></ng-content>
  <div *ngIf="canEditUser" class="card-container-button-row">
    <lib-button-primary (buttonClicked)="saveChanges()" i18n>Save Changes</lib-button-primary>
  </div>
</div>
